import React from "react";
import {Icon} from "../core/Icon.jsx";

export function Checkbox({label,description,checked,defaultChecked,disabled=false,onChange,style,...rest}){
  const isControlled=checked!==undefined;
  const [inner,setInner]=React.useState(!!defaultChecked);
  const on=isControlled?checked:inner;
  return (
    <label style={{display:"flex",gap:"10px",alignItems:"flex-start",cursor:disabled?"not-allowed":"pointer",opacity:disabled?.45:1,...style}}>
      <span style={{width:18,height:18,flex:"0 0 auto",marginTop:1,display:"inline-flex",alignItems:"center",justifyContent:"center",
        borderRadius:"var(--radius-1)",transition:"var(--transition-control)",
        background:on?"var(--surface-brand)":"var(--surface-card)",
        border:"1px solid "+(on?"var(--surface-brand)":"var(--line-strong)"),
        color:"var(--fg-invert)"}}>
        {on&&<Icon name="check" size={13} strokeAlign="middle"/>}
      </span>
      <input type="checkbox" checked={on} disabled={disabled}
        onChange={e=>{if(!isControlled)setInner(e.target.checked);onChange&&onChange(e)}}
        style={{position:"absolute",opacity:0,width:0,height:0}} {...rest}/>
      <span>
        <span style={{display:"block",fontSize:"var(--text-sm)",color:"var(--fg-1)"}}>{label}</span>
        {description&&<span style={{display:"block",fontSize:"var(--text-2xs)",color:"var(--fg-3)"}}>{description}</span>}
      </span>
    </label>
  );
}
